<div class="buttons">
  <ion-button
    *ngFor="let button of buttonConfigs"
    [disabled]="button.isDisabled"
    (click)="button.handler($event)"
    [matTooltip]="button.tooltip"
    [matTooltipDisabled]="button.isDisabled"
    [ngClass]="button.class"
    [class.missing]="button.class === 'routing' && this.routingTagGroup?.isMandatoryAndMissing"
    [attr.data-testid]="button.dataTestId"
    fill="clear">
    <ion-icon *ngIf="button.icon; else iconUrl" slot="icon-only" [name]="button.icon"></ion-icon>
    <ng-template #iconUrl>
      <ion-icon *ngIf="!button.icon" slot="icon-only" [src]="button.iconUrl"></ion-icon>
    </ng-template>
  </ion-button>
</div>

<!-- hidden tag select that will be triggered to select a team -->
<app-select-tag
  *ngIf="routingTagGroup"
  #selectRoutingTag
  [group]="routingTagGroup"
  [tagsContext]="tagsContext"></app-select-tag>
